<template>
  <v-list two-line>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Id
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ client.id }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Title
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ client.title }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Creation datetime
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ creationDate }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Report email
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ client.reportEmail }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Report send mode
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ reportSendMode }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Due time
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ formattedPeriodExecution }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Contract number
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ client.contractNumber | NoEmpty }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Contract date
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ reformatDate(client.contractDate) | NoEmpty }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {formatPeriodExecution, reformatDate} from '../../../helpers/timeformats'
import moment from 'moment'
import _ from 'lodash'
import NoEmpty from '@/components/Filters/NoEmpty'

export default {
  name: "OverviewClient",
  props: {
    client: Object
  },
  filters: {
    NoEmpty
  },
  computed: {
    ...mapGetters({
      availableReportSendModesByValues: 'clients/availableReportSendModesByValues'
    }),
    ...mapState('clients', {}),
    creationDate() {
      return moment(this.client.createdAt).format('YYYY-MM-DD HH:mm:ss')
    },
    reportSendMode() {
      return _.get(this.availableReportSendModesByValues, [this.client.reportSendMode, 'name'], '-')
    },
    formattedPeriodExecution() {
      return formatPeriodExecution(this.client.periodExecution)
    }
  },
  methods: {
    reformatDate: reformatDate
  }
}
</script>

<style scoped>

</style>